import * as bookingActions from 'actions/booking';
import moment from 'moment';
import { processDraftBookings } from 'utils/queue';

const initialState = {
  draftBookings: [],
  bookingToDequeue: null,
  bookingToQueue: null,
  selectedDate: moment(),
  bookingList: null,
  reservationsList: null,
  bookingReservationsList: null,
  liveBookings: null,
  pendingBookingList: [],
  searchBookingList: [],
  fetchingSearchBookings: false,
  fetchingPendingBookings: false,
  fetchingBookings: false,
  fetchingLiveBookings: false,
  updatingLiveBooking: false,
  creatingBooking: false,
  creatingReservation: false,
  bookingCreated: false,
  editingBooking: false,
  bookingEdited: false,
  deletingBooking: false,
  deletingReservation: false,
  UpdatingReservation: false,
  bookingDeleted: false,
  reservationUpdated: false,
  ReservationDeleted: false,
  sendingReminder: false,
  reminderSent: false,
  fetchingIQOSBookings: false,
  IQOSBookingsFetched: false,
  IQOSBookings: [],
  fetchingCompletedBookings: false,
  completedBookingsFetched: false,
  completedBookings: [],
  bookingUpdateMap: {},
};

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case bookingActions.REQUEST_BOOKINGS:
    case bookingActions.REQUEST_COMPLETED_BOOKINGS:
    case bookingActions.SET_COMPLETED_BOOKINGS:
    case bookingActions.REQUEST_IQOS_BOOKINGS:
    case bookingActions.SET_IQOS_BOOKINGS:
    case bookingActions.SET_BOOKINGS:
    case bookingActions.SET_RESERVATIONS:
    case bookingActions.SET_BOOKING_RESERVATIONS:
    case bookingActions.SET_SELECTED_DATE:
    case bookingActions.CREATED_PENDING_BOOKING:
    case bookingActions.REQUEST_CREATE_RESERVATION:
    case bookingActions.REQUEST_CREATE_BOOKING:
    case bookingActions.EDITED_BOOKING:
    case bookingActions.REQUEST_EDIT_BOOKING:
    case bookingActions.DELETED_BOOKING:
    case bookingActions.DELETED_RESERVATION:
    case bookingActions.UPDATED_RESERVATION:
    case bookingActions.REQUEST_DELETE_BOOKING:
    case bookingActions.REFUNDED_BOOKING:
    case bookingActions.REQUEST_REFUND_BOOKING:
    case bookingActions.REQUEST_PENDING_BOOKINGS:
    case bookingActions.SET_PENDING_BOOKINGS:
    case bookingActions.SEND_BOOKING_REMINDER:
    case bookingActions.SENT_BOOKING_REMINDER:
    case bookingActions.REQUEST_SEARCH_BOOKINGS:
    case bookingActions.CLEAR_BOOKING_FLAGS:
    case bookingActions.SET_SEARCH_BOOKINGS:
    case bookingActions.REQUEST_LIVE_BOOKINGS:
    case bookingActions.UPDATE_LOCAL_LIVE_BOOKINGS:
      return { ...state, ...action.payload };
    case bookingActions.SET_LIVE_BOOKINGS:
      return (() => {
        const { bookingUpdateMap } = state;
        const { fetchingLiveBookings, liveBookings } = action.payload;
        const filteredBookings = !liveBookings
          ? null
          : liveBookings.filter(b => !bookingUpdateMap[b.id]);
        return {
          ...state,
          fetchingLiveBookings,
          liveBookings: filteredBookings,
        };
      })();
    case bookingActions.LIVE_BOOKING_UPDATED:
      return (() => {
        let bookingUpdateMap = { ...state.bookingUpdateMap };
        bookingUpdateMap[action.payload.bookingId] =
          action.payload.updatingLiveBooking;
        return {
          ...state,
          updatingLiveBooking: action.payload.updatingLiveBooking,
          bookingUpdateMap,
        };
      })();
    case bookingActions.REMOVE_DRAFT_BOOKING:
      const db = [...state.draftBookings];
      const btimestamp = action.payload.bookingToDequeue.draft_timestamp;
      for (let index = 0; index < db.length; index++) {
        const existingBooking = db[index];
        const etimestamp = existingBooking.draft_timestamp;

        if (etimestamp === btimestamp) {
          console.log(`Removing ${existingBooking.name} from the Draft queue.`);
          db.splice(index, 1);
          break;
        }
      }

      processDraftBookings(db);
      return { ...state, draftBookings: db };
    case bookingActions.QUEUE_DRAFT_BOOKING:
      const draftBookings = state.draftBookings;
      const newDraftBookings = [
        ...draftBookings,
        action.payload.bookingToQueue,
      ];

      processDraftBookings(newDraftBookings);
      return { ...state, draftBookings: newDraftBookings };
    case bookingActions.PROCESS_QUEUED_BOOKINGS:
      processDraftBookings(state.draftBookings);
      return { ...state };
    default:
      return state;
  }
};

export default bookingReducer;



// WEBPACK FOOTER //
// ./src/reducers/booking/index.js